<template>
  <div class="box">
    <div class="bgbox">
      <!-- <img :src="bgImg" alt="" class="bgImg"> -->
      <div class="bgImg" :style="'background-image: url('+bgImg+');'"></div>
    </div>
    <div class="flex w1200 article">
      <div class="left"> 
        <ul class="titlelistbox">
          <li class="titlelist" v-for="(item1,index1) in memu" :key="index1">
            <div class="big" :class="{firstbig : (index1 == 0)}">
              <span>{{item1.name}}</span>
            </div>
            <div class="small" v-for="(item2,index2) in item1.list" :key="index2" @click="clickMenu(item2.value,item2.listname)">
              <span>{{item2.listname}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/Mixins/mixin_3g48.js'
export default {
  mixins:[mixins],
  data() {
    return {
      areaNameStr:"竞成",//区域名
      tableData:[],//请求来的数据
      showinfo:{//展示的数据,不包括
        name:"",
        content:"",
        catalog:"",
      },
      isDetail:false,

      bgImg: require('../images/help-banner.jpg'),
      memu: [
        {name:'关于竞成', list:[
          {listname:'竞成简介',value:'briefIntroduction'},
          {listname:'竞成理念',value:'idea'},
          {listname:'竞成文化',value:'culture'},
          {listname:'竞成团队',value:'team'},
          {listname:'竞成之路',value:'routeLine'},
          {listname:'联系我们',value:'contactUs'},
        ]},
        {name:'竞成动态', list:[
          {listname:'竞成新闻',value:'news'},
          {listname:'竞成活动',value:'activity'},
        ]},
        {name:'竞成声明', list:[
          {listname:'知识产权',value:'knowledge'},
          {listname:'网站管理',value:'website'},
          {listname:'隐私保护',value:'privacy'},
          {listname:'特别声明',value:'especially'},
        ]},
        {name:'帮助中心', list:[
          {listname:'注册登录',value:'signUp'},
          {listname:'单位会员',value:'companyVip'},
          {listname:'个人会员',value:'personalVip'},
          {listname:'如何视频',value:'video'},
        ]},
      ],
    }
  },
  watch:{
    tableData(val) {
      this.showinfo.createTime = val[0].createTime;
      this.showinfo.title = val[0].title;
      this.showinfo.viewTime = val[0].viewTime;
      this.showinfo.description = val[0].description;
      this.showinfo.content = val[0].content;
      this.showinfo.catalog = val[0].catalog;
      this.isDetail = false;
    },
    pageAreaId_x(val) {
      this.getAreaName()
    }
  },
  methods: {
    async getAreaName() {
      if (this.pageAreaId_x === '0') {
        this.areaNameStr = '竞成'
      } else {
        let rD = { areaId: this.pageAreaId_x }
        await this.$api.getPlaceName(rD).then(res => {
          if (res.data.status == 0) {
            this.areaNameStr = JSON.parse(res.data.data).name || ''
          } else { this._status(res.data) }
        })
      }
      this.$api.getSystem(this.pageAreaId_x).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c分站信息:`, 'color: #f00;', [_R], _R.siteName)
          this.bgImg = _R.helpCenterImgId ? this._img_handler(_R.helpCenterImgId) : require('../images/help-banner.jpg')

          this.memu[0].name = '关于' + (_R.siteName || this.areaNameStr || '竞成')
          this.memu[1].name = (_R.siteName || this.areaNameStr || '竞成') + '动态'
          this.memu[2].name = (_R.siteName || this.areaNameStr || '竞成') + '声明'

          this.memu[0].list[0].listname = _R.jingchengIntroduction || (this.areaNameStr || '竞成') + '简介'
          this.memu[0].list[1].listname = _R.jingchengidea || (this.areaNameStr || '竞成') + '理念'
          this.memu[0].list[2].listname = _R.jingchengCulture || (this.areaNameStr || '竞成') + '文化'
          this.memu[0].list[3].listname = _R.jingchengTeam || (this.areaNameStr || '竞成') + '团队'
          this.memu[0].list[4].listname = _R.jingchengRouteLine || (this.areaNameStr || '竞成') + '之路'
          this.memu[0].list[5].listname = _R.jingchengContactUs || '联系我们'
          this.memu[1].list[0].listname = _R.jingchengNews || (this.areaNameStr || '竞成') + '新闻'
          this.memu[1].list[1].listname = _R.jingchengActivity || (this.areaNameStr || '竞成') + '活动'
        } else { this._status(res.data) }
      })
    },
    //点击菜单，渲染不同的文章
    clickMenu(value,name) {
      const mapList1 = [
        'briefIntroduction',
        'idea',
        'culture',
        'team',
        'routeLine',
        'contactUs',
        'knowledge',
        'website',
        'privacy',
        'especially',
        'signUp',
        'companyVip',
        'personalVip',
        'video',
      ]
      const mapList2 = [
        'news',
        'activity',
      ]
      if (~mapList2.indexOf(value)) {
        // this.$router.push('articleList?catalog=' + value+"&page="+1)
        this.$router.push(`articleList?catalog=${value}&areaNameStr=${this.areaNameStr}&toptitle=${name}&page=1`)
      } else if (~mapList1.indexOf(value)) {
        // this.$router.push('articleDetail?catalog=' + value)
        this.$router.push(`articleDetail?catalog=${value}&areaNameStr=${this.areaNameStr}&toptitle=${name}`)
      }
    },
  },
  created() {
    this.getAreaName()
    document.documentElement.scrollTop = 0;
    let reqData = {
      catalog:"briefIntroduction"
    }
    this.getChenjNews(reqData);
  },
}
</script>

<style lang='scss' scoped>
/deep/.article .right .title .search input{
  border-radius: 15px;
}


.bgbox{
  width: 100%;
  height: 500px;
  min-width: 1240px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .bgImg{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
.article{
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 50px;
  /* flex-wrap:; */
}
.article .left{
  width: 20%;
  max-height: 785px;
  border: 1px solid #eeeeee;
}
.article .left .titlelistbox .titlelist .big{
  border-bottom: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  padding-left: 50px;
  color: #333333;
  font-size: 18px;
  line-height: 50px;
  background-color: #f8f8f8;
}
.article .left .titlelistbox .titlelist .firstbig{
  border-top: none;
}
.article .left .titlelistbox .titlelist .small{
  font-size: 14px;
  color:#444;
  padding-left: 50px;
  line-height: 36px;
}
.article .left .titlelistbox .titlelist .small:hover{
  cursor: pointer;
  color: #fff;
  background-color: #1E9FFF;
}
.article .right{
  width: 77%;
  height: auto;
  border: 1px solid #eeeeee;
}
.article .right .bgfff{
  background-color: #fff;
  border-bottom: 1px solid #eee;
}
.article .right .cont .list{
  align-items: flex-start;
  border-bottom: 1px solid #eeeeee;
  height: 168px;
  padding: 20px;
  transition: all .2s;
}
.article .right .cont .list:hover{
  box-shadow: 0px 0px 20px #cccccc;
}
.article .right .cont .list:hover .words>.p1{
  color: #1E9FFF;
}
.article .right .cont .list img{
  display: inline-block;
  height: 168px;
  width: 260px;
  border: 1px solid #000;
}
.article .right .cont .list .words{
  margin-left: 15px;
  flex: 1;
}
.article .right .cont .list .words .p1{
  font-size: 22px;
  margin-bottom: 10px;
}
.article .right .cont .list .words .p2{
  height: 66px;
  line-height: 33px;
  overflow: hidden;
  font-size: 14px;
  margin-bottom: 15px;
  color: #999999;
}
.article .right .cont .list .words .p3{
  font-size: 14px;
  line-height: 22px;
  color: #999999;
}
.article .right .cont .list .words .p3 span{
  display: inline-block;
}
.article .right .cont .list .words .p3 .view{
  margin-left: 100px;
}
</style>